// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faqs__faq[data-v-211c9ca5]{border:1px solid #fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
